import { Link } from "react-router-dom";

import AdsComponent from "../../../components/GoogleAds/GoogleAds";

function PublicAbout() {
    return (
        <>
            <section>
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-xl-10 mx-auto text-center">
                            {/* <!-- Title --> */}
                            <h1>If you want to discover what we do, you're in the right place.</h1>
                            <p className="lead">ID Maker is simplifying the way you manage your IDs with its innovative documents cropping and parsing Tool. The ID Maker is maintained and owned by MayankFawkes.</p>
                            {/* <!-- Meta --> */}
                            <div className="hstack gap-3 flex-wrap justify-content-center">
                                {/* <!-- Item --> */}
                                <h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
                                    <img src="/static/assets/images/element/06.svg" className="h-20px me-2" alt="" />
                                    200K+ Registered Customers
                                </h6>

                                {/* <!-- Item --> */}
                                <h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
                                    <img src="/static/assets/images/element/07.svg" className="h-20px me-2" alt="" />
                                    20K+ Happy Customers
                                </h6>

                                {/* <!-- Item --> */}
                                <h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
                                    <img src="/static/assets/images/element/card.png" className="h-20px me-2" alt="" />
                                    2.5M+ Cards Generated
                                </h6>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Image START --> */}
                    <div className="row g-4 align-items-center mx-auto">
                        {/* <!-- Image --> */}
                        <div className="col-md-5 mx-auto">
                            <img src="/static/assets/images/gif/hacker.gif" className="rounded-3" alt="" />
                        </div>

                        <div className="col-md-4 mx-auto">
                            <div className="row g-4">
                                {/* <!-- Image --> */}
                                <div className="col-md-8">
                                    <img src="/static/assets/images/gif/boi.webp" className="rounded-3 img-fluid" alt="" style={{ maxWidth: "300px" }} />
                                </div>

                                {/* <!-- Image --> */}
                                {/* <div className="col-md-8">
                                <img src="/static/assets/images/element/aboutus.png" className="rounded-3" alt="" style={{maxWidth: "300px"}}/>
                            </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <!-- Image END --> */}
                </div>
            </section>

            <section className="pt-4 pt-md-5">
                <div className="container">
                    <div className="row mb-4 mb-md-5">
                        <div className="col-md-10 mx-auto">
                            <AdsComponent dataAdSlot="5714913101" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="pt-0 pt-lg-5">
                <div className="container">
                    {/* <!-- Content START --> */}
                    <div className="row mb-4 mb-md-5">
                        <div className="col-md-10 mx-auto">
                            <h2 className="mb-4">Our Story</h2>
                            <p className="fw-bold fs-4 mb-6">
                                In 2021, My dad shared an exciting idea with me, one that had the potential to revolutionize how we manage IDs and documents.
                                He envisioned a future where this process would be simplified. We both believe that ID Maker, with its innovative Documents Cropping and Parsing Tool,
                                is well-positioned to bring this idea to life and simplify the process for businesses. Together,
                                we're looking forward to shaping the future of document management and making it more efficient and user-friendly for everyone.
                            </p>
                            <p className="mb-4 fs-4">
                                ID Maker is the brainchild of a fun project, aimed at revolutionizing the way we handle documents.
                                Our goal is simple: to replace traditional paper documents with modern and stylish PVC cards.
                                These cards are a cool and practical way to carry your important information around.
                            </p>
                            <p className="mb-4 fs-4">
                                This is not a government-affiliated website, nor are we attempting to make false claims or engage in any form of property theft.
                                It's important to note that some ID cards created/cropped by ID Maker are unofficial and should be regarded solely as informational.
                                It's possible that certain institutions, including banks and other, choose not to accept these cards as valid forms of identification.
                            </p>
                            <p className="mb-4 fs-4">
                                At ID Maker, we want to make it clear that we have no intentions of infringing on anyone's intellectual property or causing harm in any way.
                                Our mission is to simplify document management in your pocket and provide you with a more convenient way to carry your essential information.
                            </p>
                            <p className="mb-0 fs-4">
                                If you have any concerns or believe that our activities may unintentionally cause harm or claim anything improperly,
                                please don't hesitate to reach out to us at <Link className="text-primary-hover" to="mailto:support@idcard.store">support@idcard.store</Link> Your feedback is valuable, and we are here to address any questions or issues you may have.
                            </p>
                        </div>
                    </div>
                    {/* <!-- Content END --> */}
                </div>
            </section>

            <section className="pt-4 pt-md-5">
                <div className="container">
                    <AdsComponent dataAdSlot="5714913101" />
                </div>
            </section>

            <section className="pt-0">
                <div className="container">
                    <div className="bg-light p-4 p-sm-5 rounded-3 position-relative overflow-hidden">

                        {/* <!-- Svg decoration --> */}
                        <figure className="position-absolute top-0 start-0 translate-middle">
                            <svg className="fill-orange" width="250px" height="255px" viewBox="0 0 300.24 305.85">
                                <path d="M72.33,265.03c-41.74-43.54-67.69-97.8-72.24-159.79C-2.45,59.51,47.02,6.52,101.33,1.31 c61.88-6.72,117.52,12.02,155.39,64.52c16.58,23.1,27.89,49.78,35.88,75.54c18.39,55.77,2.61,105.79-37.18,136.4 c-45.06,34.18-108.2,37.69-155.75,7.58C90.6,279.3,82.55,272.11,72.33,265.03z" />
                            </svg>
                        </figure>

                        {/* <!-- Svg decoration --> */}
                        <figure className="position-absolute top-100 start-100 translate-middle">
                            <svg className="fill-warning" width="177.91px" height="132.35px" viewBox="0 0 177.91 132.35">
                                <path d="M128.84,69.77c2.74,3.33,2.92,6.79,0.71,10.54c0.77,0,1.31,0,1.79,0c7.56,0,15.12,0.3,22.68,1.13 c4.94,0.54,9.82,1.31,14.52,2.86c1.73,0.54,3.39,1.25,5,2.08c1.07,0.54,2.08,1.37,2.92,2.26c1.85,2.02,1.9,4.7,0.36,6.96 c-0.83,1.25-1.96,2.26-3.21,2.98c-2.2,1.25-4.4,2.44-6.73,3.45c-6.25,2.74-12.74,4.82-19.23,6.79c-7.98,2.44-15.95,4.76-23.93,7.14 c-0.48,0.12-1.01,0.3-1.73,0.54c0.54,0.3,0.89,0.48,1.25,0.65c1.43,0.77,2.44,1.85,2.5,3.51c0.06,1.79-0.83,3.04-2.32,3.81 c-1.19,0.6-2.56,1.13-3.87,1.49c-5.3,1.49-10.71,2.32-16.13,3.15c-10.36,1.55-20.77,2.62-31.25,3.04 c-8.93,0.36-17.8,0.36-26.67-1.01c-3.33-0.54-6.67-1.25-9.76-2.56c-1.67-0.71-3.27-1.55-4.64-2.8c-3.15-2.8-3.87-6.61-1.9-10.36 c1.01-1.9,2.44-3.51,4.05-4.94c3.15-2.8,6.79-4.94,10.48-6.85c0.6-0.3,1.25-0.65,1.85-1.19c-0.36,0-0.71,0-1.01,0 c-6.07,0.3-12.2,0.36-18.27-0.48c-2.74-0.36-5.42-0.95-8.04-2.02c-1.85-0.77-3.63-1.73-5.06-3.15c-2.62-2.62-3.45-5.71-2.5-9.29 c0.54-2.02,1.49-3.81,2.92-5.36c1.67-1.85,3.33-3.69,5.24-5.24c3.15-2.56,6.49-4.82,9.76-7.26c0.48-0.36,0.89-0.65,1.67-1.25 c-0.71-0.06-1.07-0.12-1.49-0.12c-3.57,0-7.14,0.06-10.71-0.12c-1.96-0.06-3.99-0.42-5.95-0.83c-1.19-0.24-2.38-0.71-3.45-1.31 C4.91,64,3.6,60.3,5.15,56.32c0.83-2.14,2.26-3.93,3.87-5.6c0.54-0.6,1.13-1.13,1.85-1.85c-0.48-0.06-0.77-0.12-1.07-0.12 c-1.37-0.06-2.74-0.06-4.11-0.24c-0.95-0.12-1.96-0.42-2.86-0.83c-2.56-1.25-3.51-3.93-2.32-6.49c0.48-1.01,1.19-2.02,1.96-2.74 c1.49-1.31,3.04-2.62,4.76-3.63c3.51-2.02,7.02-3.99,10.71-5.71c5.6-2.44,11.19-4.7,16.73-7.08c0.95-0.42,1.96-0.83,2.86-1.37 c8.04-4.94,16.73-8.51,25.65-11.31c14.64-4.64,29.64-7.62,45-8.93c6.19-0.54,12.38-0.65,18.51,0.18c2.38,0.3,4.7,0.77,6.9,1.79 c1.13,0.54,2.32,1.13,3.27,1.96c2.38,1.96,2.98,5,1.49,7.74c-0.6,1.13-1.37,2.2-2.32,3.04c-1.96,1.79-4.05,3.45-6.25,4.94 c-4.35,2.98-8.99,5.42-13.63,7.8c-0.48,0.24-0.89,0.48-1.37,1.01c0.6,0.06,1.13,0.12,1.73,0.24c1.13,0.24,2.26,0.42,3.33,0.77 c4.11,1.49,4.88,5.48,1.67,8.39c-1.01,0.89-2.2,1.73-3.39,2.38c-2.62,1.43-5.36,2.74-8.04,3.99c-2.38,1.07-4.76,2.08-7.2,3.33 c0.36,0.06,0.77,0.12,1.13,0.12c6.49,0.3,12.92,0.77,19.29,1.9c3.33,0.6,6.67,1.25,9.82,2.56c1.37,0.6,2.8,1.25,3.99,2.14 c3.1,2.32,3.39,5.95,0.83,8.87c-0.83,0.89-1.79,1.73-2.8,2.44c-1.67,1.13-3.45,2.02-5.18,3.04 C129.67,69.29,129.32,69.53,128.84,69.77z" />
                            </svg>
                        </figure>

                        <div className="row g-4 justify-content-md-between align-items-center position-relative">
                            <div className="col-8">
                                {/* <!-- Title --> */}
                                <h4 className="mb-0">Get in Touch</h4>
                            </div>
                            {/* <!-- Content and input --> */}
                            <div className="col-4 col-md-2 ms-auto">
                                <Link to="/contact">
                                    <button type="button" className="btn btn-dark flex-shrink-0 mb-0">Contact <i className="bi bi-arrow-right fa-fw"></i></button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default PublicAbout;